/**
 * Demo v2 · public landing at `demo.veralok.com/`.
 *
 * Two clear paths — no engineering vocabulary:
 *   • TRY IT NOW      → 60-second interactive scenario (Lane 1)
 *   • START 7-DAY TRIAL → the deeper reviewed evaluation (Lane 2)
 *
 * Only rendered when the host is the Demo host. On production hosts
 * this component is never mounted (App.js gates it).
 */
import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Zap, ShieldCheck } from "lucide-react";
import VeraLokLogo from "@/marketing/VeraLokLogo";

export default function DemoLanding() {
  return (
    <div className="vlk-demo-landing" data-testid="demo-landing">
      <header className="vlk-demo-landing-header">
        <VeraLokLogo size={28} />
        <span className="vlk-demo-landing-brand">VeraLok</span>
        <span className="vlk-demo-landing-badge" data-testid="demo-v2-header-badge">
          DEMO&nbsp;V2
        </span>
      </header>

      <section className="vlk-demo-landing-hero">
        <h1>Experience VeraLok in seconds.</h1>
        <p>
          Two paths. Pick the one that fits how you evaluate.
        </p>
      </section>

      <section className="vlk-demo-landing-lanes">
        <Link to="/demo/try" className="vlk-demo-lane vlk-demo-lane-primary"
              data-testid="demo-lane-try">
          <div className="vlk-demo-lane-icon"><Zap size={26} /></div>
          <h2>Try it now</h2>
          <p>
            Pick your sector, pick a scenario, scan the QR with your
            phone, watch VeraLok work. About 60 seconds. No signup.
          </p>
          <span className="vlk-demo-lane-cta">
            Start now <ArrowRight size={16} />
          </span>
        </Link>

        <Link to="/request-demo" className="vlk-demo-lane"
              data-testid="demo-lane-trial">
          <div className="vlk-demo-lane-icon"><ShieldCheck size={26} /></div>
          <h2>Start 7-day trial</h2>
          <p>
            Deeper institutional evaluation with your team.
            Reviewed within one business day. Time-boxed to 7 days.
          </p>
          <span className="vlk-demo-lane-cta">
            Request access <ArrowRight size={16} />
          </span>
        </Link>
      </section>

      <footer className="vlk-demo-landing-footer">
        Everything you see on demo.veralok.com runs in an isolated
        Demo v2 environment. No production VeraLok citizen data,
        identity, KYC, consent or institutional authority is ever
        touched here.
      </footer>
    </div>
  );
}
